import { toast } from 'react-toastify'

export enum FileType {
  Excel = 'Excel',
  Pdf = 'Pdf',
}

export enum FileFormat {
  PDF = 'pdf',
  XLSX = 'xlsx',
}

export const fileTypes = {
  [FileType.Excel]: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  [FileType.Pdf]: 'application/pdf',
}

type DownloadFile = {
  file: unknown
  fileName: string
  fileType: FileType
}

export const downloadFile = (fileToDownload: DownloadFile) => {
  const { file, fileName, fileType: type } = fileToDownload

  try {
    const blob = new Blob([file as BlobPart], {
      type: fileTypes[type],
    })

    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')

    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    link.parentNode?.removeChild(link)
    window.URL.revokeObjectURL(url)
  } catch (error) {
    toast.error('Houve um problema ao iniciar o download. Tente novamente mais tarde')
    console.error('Error on download file: ', error)
  }
}
